export const environment = {
  production: false,
  apiUrl: 'https://mocktest.charaka.academy/api',
  // Empty = derive from the page origin (wss:// on https). The QA web server
  // proxies /ws to the backend (port 8082).
  wsUrl: '',
};
